export default __webpack_public_path__ + "static/media/hippa.2396bf89.png";